/**
 * =====================================================
 *  WHISPERING HOMES — Buy 2 Get 2 Progress Bar (v3)
 *  File: assets/buy2get2-progress.js
 *
 *  FIX v3: Ab MutationObserver use hota hai jo poore cart drawer
 *  ko observe karta hai. Chahe kisi bhi script ne DOM replace kiya
 *  ho (theme ka native cart-drawer re-render, cross-sell.js, ya
 *  hamara khud ka code) — hum hamesha FINAL settled state ke baad
 *  render karte hain. Isse race condition (bar gayab hona) khatam
 *  ho jata hai, bina kisi fetch/XHR intercept par depend kiye.
 * =====================================================
 */

window.WhisperingBuy2Get2 = (() => {

  const COLLECTION_HANDLE = 'buy2get2';
  const CONTAINER_ID       = 'wh-buy2get2-bar';

  const TIERS = [
    { qty: 2, label: 'Buy 1 Get 1' },
    { qty: 4, label: 'Buy 2 Get 2 + 1 Gift' },
    { qty: 6, label: 'Buy 3 Get 3 + 2 Gifts' },
  ];

  let _productIdSet   = null;
  let _isRendering     = false; // guard against our own DOM writes re-triggering the observer
  let _lastRenderedQty = null;

  function _f() {
    if (!window._whNativeFetch) {
      window._whNativeFetch = window.fetch.bind(window);
    }
    return window._whNativeFetch;
  }

  async function getCollectionProductIds() {
    if (_productIdSet) return _productIdSet;
    try {
      const res = await _f()(`/collections/${COLLECTION_HANDLE}/products.json?limit=250`);
      if (!res.ok) { _productIdSet = new Set(); return _productIdSet; }
      const data = await res.json();
      _productIdSet = new Set((data.products || []).map(p => p.id));
    } catch (e) {
      _productIdSet = new Set();
    }
    return _productIdSet;
  }

  async function getQualifyingQty(cart) {
    const idSet = await getCollectionProductIds();
    if (!idSet.size) return 0;
    let qty = 0;
    (cart.items || []).forEach(item => {
      if (idSet.has(item.product_id)) qty += item.quantity;
    });
    return qty;
  }

  function buildHtml(qty) {
    let achievedIndex = -1;
    TIERS.forEach((t, i) => { if (qty >= t.qty) achievedIndex = i; });

    let heading;
    if (achievedIndex === TIERS.length - 1) {
      heading = `You've unlocked ${TIERS[achievedIndex].label}!`;
    } else {
      const nextTier = TIERS[achievedIndex + 1];
      const remaining = nextTier.qty - qty;
      heading = `Add ${remaining} product${remaining > 1 ? 's' : ''} to avail ${nextTier.label}`;
    }

    let fillPct = 0;
    if (achievedIndex >= 0) fillPct = ((achievedIndex + 1) / TIERS.length) * 100;

    const steps = TIERS.map((t, i) => {
      const done = i <= achievedIndex;
      return `
        <div class="wh-b2g2-step">
          <span class="wh-b2g2-icon ${done ? 'is-done' : 'is-locked'}">
            ${done
              ? '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3"><path d="M4 12l5 5L20 6"/></svg>'
              : '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M12 17a2 2 0 100-4 2 2 0 000 4zm6-9h-1V6a5 5 0 00-10 0v2H6a2 2 0 00-2 2v9a2 2 0 002 2h12a2 2 0 002-2v-9a2 2 0 00-2-2zm-7-2a3 3 0 016 0v2H11V6zm7 13H6v-9h12v9z"/></svg>'}
          </span>
          <span class="wh-b2g2-label">${t.label}</span>
        </div>`;
    }).join('');

    return `
      <div class="wh-b2g2-heading">${heading}</div>
      <div class="wh-b2g2-track">
        <div class="wh-b2g2-track__fill" style="width:${fillPct}%;"></div>
      </div>
      <div class="wh-b2g2-steps">${steps}</div>
    `;
  }

  // Find the current container. Themes sometimes fully replace the drawer's
  // inner HTML — meaning the ORIGINAL #wh-buy2get2-bar node may literally get
  // destroyed. If it's gone but the drawer markup is present, we re-create it
  // right after the trust badges bar so the widget keeps working either way.
  function ensureContainer() {
    let container = document.getElementById(CONTAINER_ID);
    if (container) return container;

    const trustBadges = document.querySelector('.cart-trust-badges');
    if (trustBadges && trustBadges.parentNode) {
      container = document.createElement('div');
      container.id = CONTAINER_ID;
      trustBadges.parentNode.insertBefore(container, trustBadges.nextSibling);
      return container;
    }
    return null;
  }

  async function render() {
    const container = ensureContainer();
    if (!container) return;

    try {
      const cart = await _f()('/cart.js').then(r => r.json());
      const qty  = await getQualifyingQty(cart);

      _isRendering = true;
      _lastRenderedQty = qty;

      if (qty <= 0) {
        container.style.display = 'none';
        container.innerHTML = '';
      } else {
        container.innerHTML = buildHtml(qty);
        container.style.display = 'block';
      }
    } catch (e) {
      container.style.display = 'none';
    } finally {
      // Chhota sa delay taaki innerHTML write se trigger hui mutation
      // observer callback ko hum khud ignore kar sakein
      setTimeout(() => { _isRendering = false; }, 50);
    }
  }

  function injectStyles() {
    if (document.getElementById('wh-b2g2-styles')) return;
    const s = document.createElement('style');
    s.id = 'wh-b2g2-styles';
    s.textContent = `
#${CONTAINER_ID} {
  display: none;
  margin: 14px 16px 0;
  padding: 16px;
  background: #FCE9F0;
  border: 1px solid #F3B8D2;
  border-radius: 10px;
  flex-shrink: 0;
}
.wh-b2g2-heading {
  text-align: center;
  font-weight: 600;
  font-size: var(--font-size-body, 14px);
  color: #D6197A;
  font-family: var(--font-display);
  margin-bottom: 16px;
}
.wh-b2g2-track {
  position: relative;
  height: 3px;
  background: #E3B8CB;
  border-radius: 2px;
  margin: 0 20px 10px;
}
.wh-b2g2-track__fill {
  position: absolute;
  top: 0; left: 0; height: 100%;
  background: #D6197A;
  border-radius: 2px;
  transition: width .3s ease;
}
.wh-b2g2-steps {
  display: flex;
  justify-content: space-between;
}
.wh-b2g2-step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
}
.wh-b2g2-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #D6197A;
  flex-shrink: 0;
}
.wh-b2g2-icon.is-done { background: #D6197A; color: #fff; }
.wh-b2g2-icon.is-locked { background: #fff; color: #D6197A; }
.wh-b2g2-label {
  font-size: 11px;
  font-weight: 500;
  color: #2B1D0A;
  font-family: var(--font-body);
  line-height: 1.25;
  max-width: 80px;
}
`;
    document.head.appendChild(s);
  }

  // ─────────────────────────────────────────────────────────────────
  //  MUTATION OBSERVER — cart drawer ke poore markup ko dekhta hai.
  //  Kisi bhi wajah se DOM badle (add/remove/qty-change/theme apna
  //  section re-render kare), debounce ke baad hum render() call
  //  karte hain — hamesha FINAL state ke baad, isliye bar overwrite
  //  nahi hota.
  // ─────────────────────────────────────────────────────────────────
  function watchDrawer() {
    const drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (!drawer) {
      // Drawer abhi DOM me nahi mila, thodi der baad retry karo
      setTimeout(watchDrawer, 500);
      return;
    }

    let debounceTimer = null;
    const observer = new MutationObserver((mutations) => {
      if (_isRendering) return; // apne hi update ko ignore karo

      // Agar mutation sirf hamare apne container ke andar hui hai to skip karo
      const onlySelf = mutations.every(m => {
        return m.target.id === CONTAINER_ID || m.target.closest?.(`#${CONTAINER_ID}`);
      });
      if (onlySelf) return;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(render, 250);
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    injectStyles();
    render();       // initial render (agar cart me pehle se items hain)
    watchDrawer();  // future changes ke liye observer laga do

    // Extra safety net — kuch themes custom events bhi fire karte hain
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(evt => {
      document.addEventListener(evt, () => { if (!_isRendering) render(); });
    });
  }

  return { init, render };
})();

document.addEventListener('DOMContentLoaded', function () {
  window.WhisperingBuy2Get2.init();
});